export default __webpack_public_path__ + "static/media/icon-search.96b8eaea.svg";